import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';
import {
  useColourPropAsFill,
  useHoverColorPropAsFill
} from '../../theme/tokens/color';
import { SocialIconProps } from '.';

export const IconWrapper = styled('span')<SocialIconProps>`
  margin-right: ${({ theme }) => theme.spacing.xs};

  .socialIcon {
    ${useColourPropAsFill}
    transition: 0.2s fill ease;
  }

  svg {
    width: ${({ size }) => (size === 'large' ? pxToRem(36) : pxToRem(26))};
    height: ${({ size }) => (size === 'large' ? pxToRem(36) : pxToRem(26))};
  }

  &:hover .socialIcon {
    ${useHoverColorPropAsFill}
  }
`;
